"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecipients = exports.reject = exports.suggest = exports.getLanguageIds = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var base = '/api/ai-email-template';
function getLanguageIds() {
    return api_1.default.get("".concat(base, "/languages")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getLanguageIds = getLanguageIds;
function suggest(_a) {
    var group = _a.group, languageId = _a.languageId, rejectedTemplateIds = _a.rejectedTemplateIds;
    return api_1.default.post("".concat(base, "/suggest"), { group: group, languageId: languageId, rejectedTemplateIds: rejectedTemplateIds }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.suggest = suggest;
function reject(_a) {
    var aiEmailTemplateId = _a.aiEmailTemplateId, comment = _a.comment;
    return api_1.default.post("".concat(base, "/reject"), { aiEmailTemplateId: aiEmailTemplateId, comment: comment }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.reject = reject;
function getRecipients(_a) {
    var expertIds = _a.expertIds;
    return api_1.default.post("".concat(base, "/recipients"), { expertIds: expertIds }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getRecipients = getRecipients;
var api = {
    getLanguageIds: getLanguageIds,
    suggest: suggest,
    reject: reject,
    getRecipients: getRecipients,
};
exports.default = api;
